<template>
  <div class="p-grid">
		<div class="p-col-12">
      <div class="card p-shadow-1">
				<h5>Importar Funcionários</h5>  
        <Steps :model="itens" :readonly="true"  style="margin-bottom: 1rem" />        
      </div>
      <keep-alive>
          <router-view :formData="dadosFuncionarios" @prevPage="anterior($event)" @nextPage="proximo($event)" @complete="finalizar" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itens: [        
        {label: 'Configurar', to: '/cadastros/funcionarios/importar/configurar'},
        {label: 'Validar', to: '/cadastros/funcionarios/importar/validar'},
        {label: 'Confirmar', to: '/cadastros/funcionarios/importar/confirmar'},  
        {label: 'Finaliazar', to: '/cadastros/funcionarios/importar/finalizar'},   
      ],
      dadosFuncionarios: {},
    }
  },  
  methods: {
    proximo(event) {
      for(let field in event.formData) {
        this.formObject[field] = event.formData[field];
      }
      this.$router.push(this.itens[event.pageIndex + 1].to);
    },
    anterior(event) {
      this.$router.push(this.itens[event.pageIndex - 1].to);
    },
    finalizar() {

    }
  }
}
</script>

<style>

</style>